/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class ProcessListController {
    public static $inject = [
        '$scope',
        '$state',
        'Process',
        'User',
        'bsLoadingOverlayService',
        '$uibModal',
        'toaster',
        'Employee'
    ];
    public hasPermission;
    public processList = [];
    public lprocessList = [];
    public schema;
    public form;
    public getPath;
    public leaves_item;
    public new_leave_type;
    public leave_types = [
        {id: 'all', desc: 'All'},
        {id: 'paid', desc: 'Paid'},
        {id: 'unpaid', desc: 'Unpaid'},
        {id: 'sick', desc: 'Sick'},
        {id: 'maternity', desc: 'Maternity'},
        {id: 'paternity', desc: 'Paternity'},
        {id: 'compassionate', desc: 'Compassionate'},
        {id: 'work from home', desc: 'Work from Home'},
    ];
    public documentTypes = [
        {id:'all', desc: 'All'},
        {id:'noc', desc: 'NOC'},
        {id:'salary', desc: 'salary certificate',},
        {id:'reference', desc: 'reference letter'},
        {id:'Other', desc: 'Other'}];

    public expenseTypes = [
        {id:'all', desc: 'All'},
        {id:'Travel', desc: 'Travel'},
        {id:'Fuel', desc: 'Fuel'},
        {id:'Parking', desc: 'Parking'},
        {id:'Salik', desc: 'Salik'},
        {id:'Food', desc: 'Food'},
        {id:'Entertainment', desc: 'Entertainment'},
        {id:'Client Expenses', desc: 'Client Expenses'},
        {id:'Reimbursement', desc: 'Reimbursement'},
        {id:'Other', desc: 'Other'}];

    public isHelping = false;
    public showOverlayCallOuts = false;
    public employee;
    public isTour;
    public isCurrent = -1;
    public tabs = [true, false, false, false, false, true, false, false, false, false];
    tabState: string;
    public isAdmin;
    public filterTypes = [
        {id: 'all', desc: 'All', subTypes: []},
        {id: 'leave', desc: 'Leave', subTypes: this.leave_types},
        {id: 'document', desc: 'Documents', subTypes: this.documentTypes},
        {id: 'expense', desc: 'Expenses', subTypes: this.expenseTypes},
    ];
    public inputFilter = 0;
    public inputType = 'all';
    public inputSubType = 'all';
    public inputFilterSubTypes = [];
    public inputFilterSubType = 0;
    
    public outputFilter = 0;
    public outputType = 'all';
    public outputSubType = 'all';
    public outputFilterSubTypes = [];
    public outputFilterSubType = 0;

    public requestorInputFilter = null;
    public requestorOutputFilter = null;
    public employeeFilterList = [
        {displayname: 'All', id: null},
    ];

    constructor(
        private $scope: ng.IScope,
        private $state: ng.ui.IStateService,
        private Process: IProcessService,
        private User: IUserService,
        private bsLoadingOverlayService: IBsLoadingService,
        private $uibModal: any,
        private toaster: toaster.IToasterService,
        private Employee: IEmpService) {

        this.$uibModal = $uibModal;
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.hasPermission = User.hasPermission;
        $scope.$emit('$pageWithHelpVisited', 2);
        this.isAdmin = User.getCurrentUser().userData.user.clearance === 'admin'

        this.Employee.loadEmployee(User.getCurrentUser().userData.id).then((response: Restangular.IResponse) => {
            this.isTour = this.Employee.getCoTourStatus();
            let hasVisited: Boolean = false;
            this.employee = response;

            // If not an admin, filter only by subordinates
            if (!this.isAdmin) {
                this.employeeFilterList = this.employeeFilterList.concat(this.employee.subordinates);
            }
            let list: any = this.employee.extra.help_boxes_visited;
            for (var i: any = 0; i < list.length; i++) {
                if (list[i] === 2) {
                    hasVisited = true;
                }
            }
            if (!hasVisited) {
                this.startCallouts();
            } else if (this.isTour === true) {
                this.startCallouts();
            }
            
        });

        // Admins can filter by all employees
        if (this.isAdmin) {
            this.Employee.names('')
                .then(empResponse => {
                    this.employeeFilterList = this.employeeFilterList.concat(empResponse);
                });
        } else {
            // Handled in loadEmployee promise
        }

        $scope.$emit('$processViewVisit');
    }

    public inputFilterTypeChange() {
        this.inputFilterSubTypes = this.filterTypes[this.inputFilter].subTypes;
        this.inputFilterSubType = 0;
        this.inputType =  this.filterTypes[this.inputFilter].id;
        this.inputSubType = 'all';
    }

    public inputFilterSubTypeChange() {
        this.inputSubType =  this.inputFilterSubTypes[this.inputFilterSubType].id;
    }
    
    public outputFilterTypeChange() {
        this.outputFilterSubTypes = this.filterTypes[this.outputFilter].subTypes;
        this.outputFilterSubType = 0;
        this.outputType =  this.filterTypes[this.outputFilter].id;
        this.outputSubType = 'all';
    }

    public outputFilterSubTypeChange() {
        this.outputSubType =  this.outputFilterSubTypes[this.outputFilterSubType].id;
    }

    public triggerLoad (num: number, process): any {
        this.tabs[num] = true;
        switch (num) {
            case 0:
                this.tabState = 'incoming pending'
                this.$scope.$emit('$EL', 'requests.items.incoming.pending');
                break;
            case 1:
                this.tabState = 'incoming approved'
                this.$scope.$emit('$EL', 'requests.items.incoming.approved');
                break;
            case 2:
                this.tabState = 'incoming rejected'
                this.$scope.$emit('$EL', 'requests.items.incoming.rejected');
                break;
            case 3:
                this.tabState = 'incoming deleted'
                this.$scope.$emit('$EL', 'requests.items.incoming.deleted');
                break;
            case 4:
                this.tabState = 'incoming archived'
                this.$scope.$emit('$EL', 'requests.items.incoming.archived');
                break;
            case 5:
                this.tabState = 'outgoing.pending'
                this.$scope.$emit('$EL', 'requests.items.outgoing.pending');
                break;
            case 6:
                this.tabState = 'outgoing.approved'
                this.$scope.$emit('$EL', 'requests.items.outgoing.approved');
                break;
            case 7:
                this.tabState = 'outgoing.rejected'
                this.$scope.$emit('$EL', 'requests.items.outgoing.rejected');
                break;
            case 8:
                this.tabState = 'outgoing.deleted'
                this.$scope.$emit('$EL', 'requests.items.outgoing.deleted');
                break;
            case 9:
                this.tabState = 'outgoing.archived'
                this.$scope.$emit('$EL', 'requests.items.outgoing.archived');
                break;
        }
    }

    public selectProcess = (process: any): void => {
        let subType = '';
        if (process.type === 'document' || process.type === 'leave') {
            subType = process.extra.data['type'];
        }
        this.$scope.$emit('$EL', 'requests.item.view.'+process.type, subType);
        this.$state.go('root.processes.detail', { id: process.id });
    }

    public canChangeLeaveTypeIncomming(process: any): boolean {
        // only HRMs can change incoming leave types
        if (this.User.getCurrentUser().userData.user) {
            if (this.User.getCurrentUser().userData.user.clearance !== 'admin') {
                return false;
            }
        }
        return (!process.extra.finalized && process.type === 'leave');
    }

    public canChangeLeaveTypeOutgoing(process: any): boolean {
        return (!process.extra.finalized && process.type === 'leave');
    }

    public changeLeaveType(process: any): void {
        const that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): void {
                $scope.form = ['type', 'start_date', 'end_date', 'note', 'file', 'half_day'];
                $scope.C = that;
                that.leave_types.forEach(l => {
                    if (l.id === process.extra.data.type) {
                        $scope.C.new_leave_type = l;
                    }
                });
                $scope.ok = () => {
                    let postleave: Function = (): void => {
                        that.Process.saveLeaveType(process.id, that.new_leave_type.id).then((response: any) => {
                            process.extra.data.type = that.new_leave_type.id;
                            $uibModalInstance.close(that.leaves_item);
                            that.toaster.pop('success', 'Success', 'Leave Updated');
                        }, (response: any) => {
                            if (response.status === 400) {
                                that.toaster.pop('error', 'Validation Failed', response.data[0]);
                            } else {
                                that.toaster.pop('error', 'Server Error', response.data.detail);
                            }
                        });
                    };
                    postleave();
                };
            }],
            templateUrl: '/static/templates/process/leave_change_modal.html'
        });
    }

    public deleteProcess(id: string, process: any): void {        
        this.bsLoadingOverlayService.start({ referenceId: 'requests_loader' });
        this.Process.deleteProcess(id).then((response: any) => {
            let subType = '';
            if (process.type === 'document' || process.type === 'leave') {
                subType = process.extra.data['type'];
            }

            this.$scope.$emit('$EL', 'requests.item.delete.'+process.type, subType);


            this.processList = response;
            for (let i: number = 0; i < this.processList.length; i++) {
                if (this.processList[i].type === 'warning' && this.processList[i].type === 'hidden_warning') {
                    this.processList.splice(i , 1);
                }
            }
            this.bsLoadingOverlayService.stop({ referenceId: 'requests_loader' });
            }, () => {
        });
    }

    public archiveProcess(id: string, process: any): void {
        this.bsLoadingOverlayService.start({ referenceId: 'requests_loader' });
        this.Process.archiveProcess(id).then((response: any) => {
            let subType = '';
            if (process.type === 'document' || process.type === 'leave') {
                subType = process.extra.data['type'];
            }

            this.$scope.$emit('$EL', 'requests.item.archive.'+process.type, subType);

            this.processList = response;
            for (let i: number = 0; i < this.processList.length; i++) {
                if (this.processList[i].type === 'warning' && this.processList[i].type === 'hidden_warning') {
                    this.processList.splice(i , 1);
                }
            }
            this.bsLoadingOverlayService.stop({ referenceId: 'requests_loader' });
        }, () => {
        });
    }

    public unArchiveProcess(id: string): void {
        this.bsLoadingOverlayService.start({ referenceId: 'requests_loader' });
        this.Process.unArchiveProcess(id).then((response: any) => {
        this.processList = response;
        for (let i: number = 0; i < this.processList.length; i++) {
            if (this.processList[i].type === 'warning' && this.processList[i].type === 'hidden_warning') {
                this.processList.splice(i , 1);
            }
        }
        this.bsLoadingOverlayService.stop({ referenceId: 'requests_loader' });
        }, () => {
        });
    }

    public getStatus(process: any): string {
        if (process.extra.finalized && process.extra.success) {
            return 'Approved';
        } else if (process.extra.finalized && !process.extra.success) {
            return 'Rejected';
        } else {
            return 'Pending';
        }
    }


    public nextCallout (params: any): any {
        if (this.hasPermission(params)) {
        } else if (!this.hasPermission(params)) {
            this.isCurrent = this.isCurrent + 1;
        } else if (params === 'all') {
            this.isCurrent = this.isCurrent + 1;
        }
    }

    public startCallouts = () => {
        if (this.isHelping) {
            if (this.isTour === true) {
                this.Employee.setCoTourStatus(false);
                this.isTour = this.Employee.getCoTourStatus();
            }
            this.isHelping = false;
            this.showOverlayCallOuts = false;
            this.isCurrent = -1;
        } else if (!this.isHelping) {
            this.isHelping = true;
            this.showOverlayCallOuts = true;
            this.isCurrent = 0;
        }
    }
    
    public nextTour = () => {
        this.$state.go('root.uploads');
    }
}

angular.module('beneple.process')
    .controller('ProcessListController', ProcessListController);



// WEBPACK FOOTER //
// ./frontend/scripts/process/controllers/process_list.controller.ts